module.exports = __webpack_public_path__ + "static/media/portrait-image.cb4699cf.jpg";